import { Badge, Card, LinkButton } from "@/components/ui";

export default function BillingCancelledPage() {
  return (
    <div className="mx-auto grid min-h-[70vh] max-w-xl place-items-center px-5 py-12">
      <Card className="w-full p-8 text-center">
        <Badge tone="warning">Checkout cancelled</Badge>
        <h1 className="mt-5 text-3xl font-semibold tracking-tight">
          No payment was made
        </h1>
        <p className="mx-auto mt-3 max-w-md text-sm leading-6 text-muted">
          Your cash balance has not changed. You can return to Billing whenever
          you are ready.
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <LinkButton href="/studio/billing">Return to Billing</LinkButton>
          <LinkButton href="/studio" variant="secondary">
            Back to Create
          </LinkButton>
        </div>
      </Card>
    </div>
  );
}
